'use strict';

angular.module('app').directive('toggleFilterOverlay', function () {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs, ctrl) {
      var filters = $('.filter-list')

      function checkOverlay() {
        if (filters.hasClass('visible')) {
          $('body').css({ "overflow": "hidden" });
        } else {
          $('body').removeAttr("style");
        }
      }

      $(elem).click(function(e){
        e.preventDefault();
        
        filters.toggleClass('visible');

        checkOverlay();
      });

      $(window).resize(function() {
        if (window.innerWidth >= 767) {
          filters.removeClass('visible');
          checkOverlay();
        }
      });
    }
  };
})
